import axiosConfig from './axiosConfig'
import utils from './utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  loadingCOTCG: false,
  loadingCOTCF: false,
  loadingCLTCG: false,
  loadingCLTCF: false,
  loyaltyAnalyticsDateTo: null,
  memToken: null,
  lang: 'ES'
}

// getters
const getters = {
  getMemToken () {
    return state.memToken
  },
  analyticsBussy () {
    if (state.loadingCOTCG || state.loadingCOTCF || state.loadingCLTCG || state.loadingCLTCF) {
      return true
    } else {
      return false
    }
  },
  getCOTCGloading () {
    return state.loadingCOTCG
  },
  getCOTCFloading () {
    return state.loadingCOTCF
  },
  getCLTCGloading () {
    return state.loadingCLTCG
  },
  getCLTCFloading () {
    return state.loadingCLTCF
  },
  getFechaHasta () {
    return state.loyaltyAnalyticsDateTo
  }
}

// actions
const actions = {
  async getCOTCG ({ commit, rootState }, data) {
    commit('LOADING_COTCG', true)
    // console.log(`getCOTCG data ${state.lang}`, data)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    console.log(`pretoken COTCG: ${sessionStorage.getItem('token')}`)
    const hashToken = utils.SHA256(`${appParams.entidad}${sessionStorage.getItem('token')}${appParams.canal}`)
    const body = {
      runService: {
        opData: {
          avanzar: data && data.avanzar ? 'true' : 'false',
          businesstimeout: '',
          canal: config.canal,
          claveFin: data && data.claveFin ? data.claveFin : 20,
          claveInicio: data && data.claveInicio ? data.claveInicio : 1,
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: data && data.indMasDatos ? data.indMasDatos : '',
          oficina: '0001',
          pantPagina: data && data.pantPagina ? data.pantPagina : '',
          retroceder: data && data.retroceder ? 'true' : 'false',
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          codentid: config.entidad,
          codprogr: appProgram,
          contadordia2h: 0,
          contadordia2m: 0,
          contadordia2n: 0,
          contadordia3h: 0,
          contadordia3m: 0,
          contadordia3n: 0,
          contadordia4h: 0,
          contadordia4m: 0,
          contadordia4n: 0,
          contadordia5h: 0,
          contadordia5m: 0,
          contadordia5n: 0,
          contadordia6h: 0,
          contadordia6m: 0,
          contadordia6n: 0,
          contadordia7h: 0,
          contadordia7m: 0,
          contadordia7n: 0,
          contadordiahoyh: 0,
          contadordiahoym: 0,
          contadordiahoyn: 0,
          fechadesde: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechadia2: '',
          fechadia3: '',
          fechadia4: '',
          fechadia5: '',
          fechadia6: '',
          fechadia7: '',
          fechadiahoy: '',
          fechahasta: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: state.loyaltyAnalyticsDateTo
          },
          totalclientes: 0,
          totalhombres: 0,
          totalmujeres: 0,
          totalnoinfo: 0
        }
      }
    }
    try {
      // console.log('body COTCG', body)
      const response = await HTTP.post(config.endpoints.getCOTCG, body)
      const newToken = response.data.runServiceResponse.return.securityToken
      console.log('postoken COTCG: ', newToken)
      commit('SET_MEM_TOKEN', newToken)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      } else {
        commit('LOADING_COTCG', false)
        return response.data.runServiceResponse.return
      }
    } catch (error) {
      console.log(error)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getCOTCF ({ commit, rootState }, data) {
    commit('LOADING_COTCF', true)
    // console.log('getCOTCF data ', data)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    console.log(`pretoken COTCF: ${sessionStorage.getItem('token')}`)
    const hashToken = utils.SHA256(`${appParams.entidad}${sessionStorage.getItem('token')}${appParams.canal}`)
    // console.log(typeof data)
    const body = {
      runService: {
        opData: {
          avanzar: data && data.avanzar ? 'true' : 'false',
          businesstimeout: '',
          canal: config.canal,
          claveFin: data && data.claveFin ? data.claveFin : 20,
          claveInicio: data && data.claveInicio ? data.claveInicio : 1,
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: data && data.indMasDatos ? data.indMasDatos : '',
          oficina: '0001',
          pantPagina: data && data.pantPagina ? data.pantPagina : '',
          retroceder: data && data.retroceder ? 'true' : 'false',
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          codentid: config.entidad,
          codprogr: appProgram,
          contadordia2h: 0,
          contadordia2m: 0,
          contadordia2n: 0,
          contadordia3h: 0,
          contadordia3m: 0,
          contadordia3n: 0,
          contadordia4h: 0,
          contadordia4m: 0,
          contadordia4n: 0,
          contadordia5h: 0,
          contadordia5m: 0,
          contadordia5n: 0,
          contadordia6h: 0,
          contadordia6m: 0,
          contadordia6n: 0,
          contadordia7h: 0,
          contadordia7m: 0,
          contadordia7n: 0,
          contadordiahoyh: 0,
          contadordiahoym: 0,
          contadordiahoyn: 0,
          fechadesde: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechadia2: '',
          fechadia3: '',
          fechadia4: '',
          fechadia5: '',
          fechadia6: '',
          fechadia7: '',
          fechadiahoy: '',
          fechahasta: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: state.loyaltyAnalyticsDateTo
          },
          totalclientes: 0,
          totalhombres: 0,
          totalmujeres: 0,
          totalnoinfo: 0
        }
      }
    }
    try {
      // console.log('body COTCF', body)
      const response = await HTTP.post(config.endpoints.getCOTCF, body)
      const newToken = response.data.runServiceResponse.return.securityToken
      console.log('postoken COTCF: ', newToken)
      commit('SET_MEM_TOKEN', newToken)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      } else {
        if (typeof newToken === 'object') {
          console.log('No se pudo refrescar el Token de seguridad.')
        }
        commit('LOADING_COTCF', false)
        return response.data.runServiceResponse.return
      }
    } catch (error) {
      console.log(error)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getCLTCG ({ commit, rootState }, data) {
    commit('LOADING_CLTCG', true)
    // console.log('getCLTCG data ', data)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    console.log(`pretoken CLTCG: ${sessionStorage.getItem('token')}`)
    const hashToken = utils.SHA256(`${appParams.entidad}${sessionStorage.getItem('token')}${appParams.canal}`)
    // console.log(typeof data)
    const body = {
      runService: {
        opData: {
          avanzar: data && data.avanzar ? 'true' : 'false',
          businesstimeout: '',
          canal: config.canal,
          claveFin: data && data.claveFin ? data.claveFin : 20,
          claveInicio: data && data.claveInicio ? data.claveInicio : 1,
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: data && data.indMasDatos ? data.indMasDatos : '',
          oficina: '0001',
          pantPagina: data && data.pantPagina ? data.pantPagina : '',
          retroceder: data && data.retroceder ? 'true' : 'false',
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          cliente: '',
          codcuent: '',
          codentid: config.entidad,
          codpostal: '',
          codprogr: appProgram,
          destidc: '',
          fecdesde: '',
          fechasta: state.loyaltyAnalyticsDateTo,
          fecnac: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          idclient: '',
          indestciv: '',
          sexo: '',
          tipidcli: '',
          tipidext: '',
          tipoconsulta: data.tipCons ? data.tipCons : 'T'
        }
      }
    }
    try {
      // console.log('body CLTCG', body)
      const response = await HTTP.post(config.endpoints.getCLTCG, body)
      const newToken = response.data.runServiceResponse.return.securityToken
      commit('SET_MEM_TOKEN', newToken)
      console.log('postoken CLTCG: ', newToken)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      } else {
        if (typeof newToken === 'object') {
          console.log('No se pudo refrescar el Token de seguridad.')
        }
        commit('LOADING_CLTCG', false)
        return response.data.runServiceResponse.return
      }
    } catch (error) {
      console.log(error)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getCLTCF ({ commit, rootState }, data) {
    commit('LOADING_CLTCF', true)
    // console.log('getCLTCF data ', data)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    console.log(`pretoken CLTCF: ${sessionStorage.getItem('token')}`)
    const hashToken = utils.SHA256(`${appParams.entidad}${sessionStorage.getItem('token')}${appParams.canal}`)
    const body = {
      runService: {
        opData: {
          avanzar: data && data.avanzar ? 'true' : 'false',
          businesstimeout: '',
          canal: config.canal,
          claveFin: data && data.claveFin ? data.claveFin : 20,
          claveInicio: data && data.claveInicio ? data.claveInicio : 1,
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: data && data.indMasDatos ? data.indMasDatos : '',
          oficina: '0001',
          pantPagina: data && data.pantPagina ? data.pantPagina : '',
          retroceder: data && data.retroceder ? 'true' : 'false',
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          cantpunt: 0,
          cliente: '',
          codcuent: '',
          codentid: config.entidad,
          codprogr: appProgram,
          destidc: '',
          estado: '',
          fechadesde: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechahasta: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: state.loyaltyAnalyticsDateTo
          },
          idclient: '',
          indblqac: '',
          indblqrd: '',
          tipcons: data && data.tipCons ? data.tipCons : 'T'
        }
      }
    }
    try {
      // console.log('body CLTCF', body)
      const response = await HTTP.post(config.endpoints.getCLTCF, body)
      const newToken = response.data.runServiceResponse.return.securityToken
      console.log('postoken CLTCF: ', newToken)
      commit('SET_MEM_TOKEN', newToken)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      } else {
        if (typeof newToken === 'object') {
          console.log('No se pudo refrescar el Token de seguridad.')
        }
        commit('LOADING_CLTCF', false)
        return response.data.runServiceResponse.return
      }
    } catch (error) {
      console.log(error)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  updateDateTo ({ commit }, data) {
    commit('SET_FECHA_HASTA', data)
  }

}

// mutations
const mutations = {
  'SET_MEM_TOKEN' (state, actions) {
    sessionStorage.setItem('token', actions)
    console.log(`SET_MEM_TOKEN ${actions}`)
    state.memToken = actions
  },
  'LOADING_COTCG' (state, actions) {
    state.loadingCOTCG = actions
  },
  'LOADING_COTCF' (state, actions) {
    state.loadingCOTCF = actions
  },
  'LOADING_CLTCG' (state, actions) {
    state.loadingCLTCG = actions
  },
  'LOADING_CLTCF' (state, actions) {
    state.loadingCLTCF = actions
  },
  'SET_FECHA_HASTA' (state, actions) {
    state.loyaltyAnalyticsDateTo = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
